














import Vue, { PropType } from "vue";
import VueClipboard from "vue-clipboard2";

Vue.use(VueClipboard);

export interface CopyProps {
  copyText: string;
  captionText: string;
}

export default Vue.extend({
  name: "vc-copy",
  props: {
    copyText: {
      type: String as PropType<CopyProps["copyText"]>,
      default: ""
    },
    captionText: {
      type: String as PropType<CopyProps["captionText"]>,
      default: ""
    }
  },
  methods: {
    onCopy: function() {
      alert("copy success");
    },
    onError: function() {
      alert("Failed to copy texts");
    }
  }
});
